// @flow

import * as React from 'react';
import {Handle, Position} from 'react-flow-renderer';
import Box from 'sail/Box';
import {BodyAlt} from 'sail/Text';

import './OverviewDiagram.scss';

type OverviewDiagramTextNodeData = {|
  text: string,
|};

type OverviewDiagramNodeProps = {|
  data: OverviewDiagramTextNodeData,
|};

export const OverviewDiagramTextNode = ({data}: OverviewDiagramNodeProps) => {
  const {text} = data;

  return (
    <Box
      className={'OverviewDiagramTextNode'}
      flex={{alignItems: 'center', justifyContent: 'center'}}
      background="white"
      padding={32}
    >
      <Handle
        type="target"
        position={Position.Top}
        id="top"
        style={{left: '50%', top: '0%'}}
      />
      <Handle
        type="source"
        position={Position.Top}
        id="top"
        style={{left: '50%', top: '0%'}}
      />
      <Handle
        type="target"
        id="left"
        position={Position.Left}
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Left}
        id="left"
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="bottom"
        style={{left: '50%', top: '100%'}}
      />
      <Box flexBasis="100%" flex={{alignItems: 'center', direction: 'column'}}>
        <BodyAlt align="center" color={'gray900'}>
          {text}
        </BodyAlt>
      </Box>
      <Handle
        type="target"
        id="right"
        position={Position.Right}
        style={{top: '50%'}}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="right"
        style={{top: '50%'}}
      />
    </Box>
  );
};
